import { Link } from 'react-router-dom';
import { tokens } from '../../theme';
import { Pegasus } from '../DreamlinkMark';

type NavTheme = 'blue' | 'night';

// Maroon brand accent on light surfaces; cream on dark (night) surfaces.
const MAROON = '#590b11';
const CREAM = '#F5F2EE';

export function PublicNav({
  onDarkHero = false,
  theme = 'blue',
}: {
  onDarkHero?: boolean;
  theme?: NavTheme;
}) {
  const night = theme === 'night';

  const fg = night ? CREAM : onDarkHero ? '#fff' : tokens.color.ink[900];
  const accent = night ? CREAM : MAROON;
  const accentInk = night ? MAROON : CREAM;
  const bg = night
    ? onDarkHero
      ? 'transparent'
      : 'rgba(26,6,8,0.85)'
    : onDarkHero
      ? 'transparent'
      : 'rgba(245,242,238,0.94)';
  const blur = onDarkHero ? 'none' : 'saturate(160%) blur(12px)';
  const border = onDarkHero
    ? 'none'
    : `1px solid ${night ? '#4a1a1d' : tokens.color.line[100]}`;

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        padding: '16px 28px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: fg,
        background: bg,
        backdropFilter: blur,
        WebkitBackdropFilter: blur,
        borderBottom: border,
        transition: 'background 240ms ease, color 240ms ease, border-color 240ms ease',
      }}
    >
      <Link
        to="/"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 10, color: 'inherit' }}
      >
        <Pegasus size={22} color="currentColor" />
        <span
          style={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontWeight: 500,
            fontSize: 19,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
            lineHeight: 1,
          }}
        >
          Dreamlink{' '}
          <span style={{ fontStyle: 'italic', textTransform: 'none', letterSpacing: '0.02em', opacity: 0.85 }}>
            Studio
          </span>
        </span>
      </Link>

      <ul
        style={{
          display: 'flex',
          gap: 24,
          listStyle: 'none',
          alignItems: 'center',
          fontSize: 12,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
        }}
        className="ls-nav-links"
      >
        <li className="ls-nav-hide-mobile">
          <Link to="/clipping" style={{ color: 'inherit' }}>
            Clipping
          </Link>
        </li>
        <li className="ls-nav-hide-mobile">
          <Link to="/localization" style={{ color: 'inherit' }}>
            Localization
          </Link>
        </li>
        <li className="ls-nav-hide-mobile">
          <Link to="/inquire" style={{ color: 'inherit' }}>
            For brands
          </Link>
        </li>
        <li>
          <Link
            to="/clipper"
            style={{
              padding: '9px 16px',
              background: accent,
              color: accentInk,
              borderRadius: 999,
              letterSpacing: '0.1em',
              fontWeight: 600,
            }}
          >
            Start clipping
          </Link>
        </li>
      </ul>
    </nav>
  );
}
